/**
 * Landing Pages Constants
 * Shared constants across landing page feature
 */

/**
 * Error Messages
 */
export const ERROR_MESSAGES = {
  UPLOAD_FAILED: "Failed to upload image. Please try again.",
  CREATE_FAILED: "Failed to create landing page. Please try again.",
  DELETE_FAILED: "Failed to delete landing page. Please try again.",
  USER_NOT_FOUND: "User not found. Please log in and try again.",
  VALIDATION_ERROR: "Validation error, skipping auto-save:",
  USER_OR_PAGE_UNDEFINED: "User ID or landing page ID is undefined",
  AUTO_SAVE_FAILED: "Failed to auto-save landing page",
  CTA_VALIDATION: "CTA Button Text and CTA Button Link must both be filled or both be empty",
  ACCESS_DENIED_PRIVATE: "This landing page is only accessible to event admins and owners.",
  ACCESS_DENIED_INVITED: "This landing page is only accessible to invited attendees.",
} as const;

/**
 * Default Values
 */
export const DEFAULT_VALUES = {
  HERO_TITLE: "Welcome",
  VENUE_NAME: "Venue Name",
  SCHEDULE_TITLE: "Event Schedule",
  PRIVACY_LEVEL: "private" as const,
} as const;

/**
 * Privacy Level Descriptions
 */
export const PRIVACY_DESCRIPTIONS = {
  private: "Only event admins and owners can view this page",
  invited: "Event admins, owners, and invited attendees can view this page",
  public: "Anyone with the link can view this page",
} as const;

/** Debounce delay in ms for V2 slug validation */
export const SLUG_V2_DEBOUNCE_MS = 500;

/** Duration in ms to show the "copied" feedback on a link copy button */
export const COPY_FEEDBACK_DURATION_MS = 2000;
